module.exports = __webpack_public_path__ + "img/SKMJ_heavy1.9868e8a0.png";